import { BrowserRouter } from "react-router";
import { AuthProvider } from "@src/presentation/providers/AuthProvider";
import { AppRoutes } from "@src/presentation/routes/AppRoutes";
import { ToastProvider } from "@ir/ui";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import "./App.scss";

/**
 * Main App Component
 * Single Responsibility: Application entry point and provider setup
 */
function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <AppRoutes />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
